import { isDailyRent } from './isDailyRent';
import { ELabelColor, IOfferCard } from '../../../types';

export const getIsUniqueLabel = ({ category, promoInfo, isUnique }: IOfferCard) => {
  if (isDailyRent(category) || !isUnique || promoInfo?.isExclusive) {
    return null;
  }

  return {
    color: ELabelColor.Blue,
    text: 'Только на Циан',
  };
};
